/* src/app/views/collection/components/modals/edit-collection-save-confirmation/edit-collection-save-confirmation.component.scss */
.edit-collection-save-confirmation-container {
  padding-inline: 0.2rem;
}
/*# sourceMappingURL=edit-collection-save-confirmation.component.css.map */
